<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl md:text-3xl ">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('bank_statements')">Wyciągi</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ bank_statement.id }}
    </h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.description" :error="form.errors.description" label="Opis"  />
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['edit bank statement']">
            <button v-if="!bank_statement.is_imported && $page.props.can['delete bank statement']" class="text-red-600 hover:underline mr-5" tabindex="-1" type="button" @click="destroy">Usuń wyciąg</button>
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Aktualizuj opis</loading-button>
          </div>
        </form>
      </div>
    </div>
    
    <h2 class="mt-12 font-bold text-xl md:text-2xl relative" v-if="!bank_statement.is_imported && $page.props.can['import bank statement']">
      Pozycje
    </h2>
    
    <form @submit.prevent="import_data" v-if="!bank_statement.is_imported && $page.props.can['import bank statement']">
      <div class="mt-6 bg-white rounded shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap text-xs">
            <tr class="text-left font-bold">
              <th class="px-3 pt-2 pb-4">Klient</th>
              <th class="px-3 pt-2 pb-4" v-for="head in bank_statement.content.headers">{{ head }}</th>
            </tr>
            <tr v-for="(pos, index) in bank_statement.content.data" :key="index" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                    <span class="px-3 py-1 flex items-center focus:text-shtax-500">
                      <multiselect-input v-model="pos_form.clients[index].client_id" :options="clients" track_by="id" opt_label="nazwa_pelna" :multiple="false" :close_on_select="true" :searchable="true" class="w-96 multiselect-sm" />
                    </span>
              </td>
              <td class="border-t">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                      {{ pos.data_operacji }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.data_ksiegowania">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                      {{ pos.data_ksiegowania }}
                    </span>
              </td>
              <td class="border-t">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
                      {{ pos.opis_operacji }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.tytul">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
                      {{ pos.tytul }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.nadawca_odbiorca">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
                      {{ pos.nadawca_odbiorca }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.rachunek">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
                      {{ pos.rachunek }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.numer_konta">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                      {{ pos.numer_konta }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.kategoria">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500 whitespace-normal">
                      {{ pos.kategoria }}
                    </span>
              </td>
              <td class="border-t">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                      {{ pos.kwota }}
                    </span>
              </td>
              <td class="border-t" v-if="pos.saldo_po_operacji">
                    <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                      {{ pos.saldo_po_operacji }}
                    </span>
              </td>
            </tr>
            <tr v-if="bank_statement.content.data.length === 0">
              <td class="border-t px-3 py-2" colspan="8">Brak pozycji na wyciągu.</td>
            </tr>
          </table>

      </div>
      <div class="py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['import bank statement']">
        <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit" :disabled="disabled">Importuj powiązane</loading-button>
      </div>
    </form>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return { title: 'Pozycje na wyciągu: '+ this.bank_statement.id }
  },
  components: {
    Icon,
    LoadingButton,
    TextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    bank_statement: Object,
    clients: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        description: this.bank_statement.description
      }),
      pos_form: this.$inertia.form({
        clients: []
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('bank_statements.update', this.bank_statement.id))
    },
    import_data() {
      let i = this.pos_form.clients.filter((client) => {return client.client_id != null}).length
      let text = i +' wybranych pozycji'
      if (i < 5 && i > 1)
        text = i +' wybrane pozycje'
      if (i == 1)
        text = 'tylko '+ i +' wybraną pozycję'

      Swal.fire({
        title: 'Jesteś pewien że chcesz zaimportować '+ text +' wyciągu?',
        text: 'import innych pozycji z tego wyciągu nie będzie już możliwy',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, importuj!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.pos_form.put(this.route('bank_statements.import', this.bank_statement.id))
        }
      })

    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz usunąć wybrany wyciąg?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('bank_statements.destroy', this.bank_statement.id))
        }
      })
    },

    arr_get(arr, key) {
      return arr[key.toLowerCase().replace(' ', '_').replace('ę', 'e').replace('ł', 'l').replace('/', '_')]
    }
  },

  computed: {
    disabled() {
      return this.pos_form.clients.filter((client) => {return client.client_id != null}).length == 0
    }
  },

  mounted() {
  },

  created() {
    this.bank_statement.content.data.forEach((position) => {this.pos_form.clients.push({ pos: position, client_id: null })})
  }

}
</script>
